"use strict";

exports.__esModule = true;
exports.PredefinedCommentsScreenContainer = exports.CommentLine = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PredefinedCommentsScreenContainer = exports.PredefinedCommentsScreenContainer = _styledComponents["default"].article.withConfig({
  displayName: "styles__PredefinedCommentsScreenContainer",
  componentId: "sc-11hbbsl-0"
})(["padding:0 1rem;overflow-y:auto;"]);
var CommentLine = exports.CommentLine = _styledComponents["default"].div.withConfig({
  displayName: "styles__CommentLine",
  componentId: "sc-11hbbsl-1"
})(["display:flex;justify-content:space-between;margin:1rem 0;"]);